/**
 * Resolves the canonical invoice primary key used by the API (client_invoice_id).
 */
export function getClientInvoiceId(invoice) {
  if (!invoice || typeof invoice !== "object") return null;

  const sources = [
    invoice,
    invoice._invoiceData,
    invoice._invoiceRaw,
  ];

  for (const src of sources) {
    if (!src || typeof src !== "object") continue;
    const id =
      src.client_invoice_id ??
      src.clientInvoiceId ??
      src.invoice_id ??
      src.invoiceId ??
      src.Invoice_id;
    if (id !== undefined && id !== null && id !== "") {
      return id;
    }
  }

  return null;
}
